// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB2JO1Hgk2vP6XzfFaCTF-Iu8GoD0C7RNo",
  authDomain: "gobiesclean-10007.firebaseapp.com",
  projectId: "gobiesclean-10007",
  storageBucket: "gobiesclean-10007.firebasestorage.app",
  messagingSenderId: "1082208129531",
  appId: "1:1082208129531:web:21cf4447365702a99c7b5e",
  measurementId: "G-Q0GPBDY3KV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { db };
export const auth = getAuth(app);